import axios from "axios";
import { merge } from "lodash";
import { reactive } from "vue";

export const userStore = reactive({
    data: {},
});

export const getUserData = async (retries = 3) => {
    if (
        userStore.data &&
        typeof userStore.data === "object" &&
        Object.keys(userStore.data).length > 0
    ) {
        return;
    }

    try {
        const response = await axios.get(route("data.get.user.data"));

        merge(userStore.data, response.data.data);
    } catch (error) {
        console.error("Error fetching user data:", error);
        if (retries > 0) {
            setTimeout(() => {
                getUserData(retries - 1);
            }, 1000);
        }
    }
};

export const getSpecificUserData = async (type) => {
    if (!type) return;

    try {
        const response = await axios.get(
            route("data.get.specific.user.data", { type })
        );

        const current = userStore.data[type];
        const incoming = response.data.data[type];

        userStore.data[type] = current ? merge(current, incoming) : incoming;
    } catch (error) {
        console.error("Error fetching specific data:", error);
    }
};
